const sectors = [
  { value: undefined, label: 'Select...' },
  { value: 'administrative support', label: 'Administrative Support' },
  { value: 'arts entertainment & recreation', label: 'Arts Entertainment & Recreation' },
  { value: 'educational services', label: 'Educational Services' },
  { value: 'finance & insurance', label: 'Finance & Insurance' },
  { value: 'health care', label: 'Health Care' },
  { value: 'hospitality & food services', label: 'Hospitality & Food Services' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'marketing & communications', label: 'Marketing & Communications' },
  { value: 'public administration', label: 'Public Administration' },
  { value: 'retail & whole sale', label: 'Retail & Whole Sale' },
  { value: 'science & tech', label: 'Science & Tech' },
  { value: 'trades & construction', label: 'Trades & Construction' },
];

export default sectors;



// WEBPACK FOOTER //
// ./src/components/pages/Careers/Sectors.js